import { Component, ViewEncapsulation, inject } from '@angular/core';
import { SystemService } from '../../shared/service/system/system.service';
import { LayoutService } from '../service/layout.service';
import { TopPanelComponent } from '../top-panel/top-panel.component';
import { LeftPanelComponent } from '../left-panel/left-panel.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-layout',
  templateUrl: './main-window.component.html',
  styleUrls: ['./main-window.component.scss'],
  standalone: true,
  imports: [CommonModule, TopPanelComponent, LeftPanelComponent, RouterModule, RouterOutlet, TranslateModule],
  encapsulation: ViewEncapsulation.None,
})
export class MainWindowComponent {
  protected systemService = inject(SystemService);
  protected layoutService = inject(LayoutService);
  private router = inject(Router);

  isAuthRoute = false;
  private authRoutes = ['/login', '/logout', '/mfa', '/mfa-settings-modal', '/reset-password', '/timeout'];

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.isAuthRoute = this.authRoutes.some((route) => event.urlAfterRedirects.startsWith(route));
    });
  }
  protected readonly JSON = JSON;
}
